export default __webpack_public_path__ + "static/media/logo.1e9b3fb6.svg";